module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAAA6UlEQVQ4T+2SsU7CUBiFv2OIC4NMxsdQfAuHUkxkc/bVTBlgUhISYDZREvcuZWABXTUFfkJDSaHclgfgjvc/+e455/7CcfyO1bRgaGI2mfPw+aLYpdWxQQoAbpO50Yt+8VygHCQHSF8pAO1BngK7isVIqYO8zffoh8ahox0kAcBI2kZwFGDibTLHz4ISyKmAXbIDkLYRhoI7V/vH7rOO5Ac2LotQAB/8VWnq8dXqqrDYCFdGH7gucfR9IZ43mhgul/+Ee7/TbNsUuCmEGF+dlu6zmjPk3EluZ0r3JLAPRLVo2cwIuy15Wc0a9e6SIE0UajQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/takeOffImg.png
// module id = 7PnA
// module chunks = 2